import {
    GET_CUSTOM_TAB, GET_CUSTOM_TAB_ERROR,
    GET_CUSTOM_TAB_SUCCESS,
    UPDATE_CUSTOM_TAB,
    UPDATE_CUSTOM_TAB_SUCCESS,
    UPDATE_CUSTOM_TAB_ERROR,
    GET_CUSTOM_SORTED_TAB,
    GET_CUSTOM_SORTED_TAB_SUCCESS,
    GET_CUSTOM_SORTED_TAB_ERROR,
    UPDATE_CUSTOM_SORTED_TAB,
    UPDATE_CUSTOM_SORTED_TAB_SUCCESS,
    UPDATE_CUSTOM_SORTED_TAB_ERROR,
} from "../types";

export const customTabReducer = (state, action) => {
    switch (action.type) {
        case GET_CUSTOM_TAB:
            return {
                ...state,
                customTabLoading: true,
                customTabError: false,
                error: null,
            };
        case GET_CUSTOM_TAB_SUCCESS:
            return {
                ...state,
                customTabData: action.payload,
                customTabLoading: false,
                error: null,
            };
        case GET_CUSTOM_TAB_ERROR:
            return {
                ...state,
                customTabData: null,
                customTabLoading: false,
                customTabError: true,
                error: action.payload,
            };
        case UPDATE_CUSTOM_TAB:
            return {
                ...state,
                customTabUpdateLoading: true,
                customTabUpdateError: false,
                error: null,
            };
        case UPDATE_CUSTOM_TAB_SUCCESS:
            return {
                ...state,
                customTabUpdateLoading: false,
                customTabUpdateError: false,
                error: null,
            };
        case UPDATE_CUSTOM_TAB_ERROR:
            return {
                ...state,
                customTabUpdateLoading: false,
                customTabUpdateError: true,
                error: action.payload,
            };
        case GET_CUSTOM_SORTED_TAB:
            return {
                ...state,
                customSortedTabLoading: true,
                customSortedTabError: false,
                error: null,
            };
        case GET_CUSTOM_SORTED_TAB_SUCCESS:
            return {
                ...state,
                customSortedTabData: action.payload,
                customSortedTabLoading: false,
                error: null,
            };
        case GET_CUSTOM_SORTED_TAB_ERROR:
            return {
                ...state,
                customSortedTabData: null,
                customSortedTabLoading: false,
                customSortedTabError: true,
                error: action.payload,
            };
        case UPDATE_CUSTOM_SORTED_TAB:
            return {
                ...state,
                customSortedTabUpdateLoading: true,
                customSortedTabUpdateError: false,
                error: null,
            };
        case UPDATE_CUSTOM_SORTED_TAB_SUCCESS:
            return {
                ...state,
                customSortedTabUpdateLoading: false,
                customSortedTabUpdateError: false,
                error: null,
            };
        case UPDATE_CUSTOM_SORTED_TAB_ERROR:
            return {
                ...state,
                customSortedTabUpdateLoading: false,
                customSortedTabUpdateError: true,
                error: action.payload,
            };
        default:
            return null;
    }
};